import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackChargingCostParamenterChangeEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

interface UseLegacyTrackChargingCostParameterChangeVariables {
  vehicle: ElasticVehicle;
  information: {
    context: 'modal';
    parameter: 'distance-slider' | 'distance-dropdown' | 'cost-input';
    disance: string;
    chargingCost?: number;
  };
}

export const createLegacyTrackChargingCostParameterChange = (
  market: Market,
  variables: UseLegacyTrackChargingCostParameterChangeVariables,
): LegacyTrackChargingCostParamenterChangeEventData => {
  const eventData: LegacyTrackChargingCostParamenterChangeEventData = {
    eventType: 'chargingCostParameterChange',
    item: mapElasticVehicleToLegacyItem(market, variables.vehicle),
    pageType: 'product page',
    information: variables.information,
  };

  return eventData;
};

export const useLegacyTrackChargingCostParameterChange = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyChargingCostParameterChange = useCallback(
    (variables: UseLegacyTrackChargingCostParameterChangeVariables) => {
      track({
        event: 'chargingCostParameterChange',
        data: createLegacyTrackChargingCostParameterChange(market, variables),
      });
    },
    [track],
  );

  return {
    trackLegacyChargingCostParameterChange,
  };
};
